Jelly.Utilities.Force_URL = function(Path) {
	window.clearInterval(Jelly.Watch_Address_Bar_Interval);

	try {
		var URL = new window.URL(Path, window.location.href);
		var URL_Hostname = URL.hostname.replace(/^www\./, "");
		var Current_Hostname = window.location.hostname.replace(/^www\./, "");
		if (URL_Hostname == Current_Hostname && URL.origin != window.location.origin) {
			Path = URL.pathname + URL.search + URL.hash;
		}
	} catch (Exception) {}

	// Normalize the passed URL/path into Jelly.Current_Path (ignore hash, include pathname+search).
	var New_Path = Jelly.URL.Get_Path_From_URL(Path);
		
	// Push this new path
	Jelly.Current_Path = New_Path;

	// State change to original path
	window.history.pushState(null, null, Path);
	// Polling is fallback-only; event-driven hooks in Jelly.Navigation handle the common case.
	Jelly.Watch_Address_Bar_Interval = window.setInterval(Jelly.Watch_Address_Bar, 500);
}
